import type { CareTeamMember } from '../types'

import _ from 'lodash'
import Select from 'react-select'

import * as Grid from '../../../../../shared/grid'

type ParticipantListItems = Array<{value: { reference: string, display: string }, label: string}>
const participantToListItems = (participant?: CareTeamMember[]): ParticipantListItems => {
  if (!participant) {
    return []
  }
  return participant.map(mem => {
    const names = [
      _.get(mem, 'name[0].given[0]'),
      _.get(mem, 'name[0].family[0]'),
      _.get(mem, 'name[0].suffix[0]')
    ].filter(x => !!x)
    const name = names.join(' ')
    return {
      value: {
        reference: `${mem.resourceType}/${mem.id}`,
        display: name
      },
      label: name
    }
  })
}

interface CareTeamMemberSelectProps {
  careTeamMembers?: CareTeamMember[]
  onChange: (value: {reference: string, display: string} | null | undefined) => void
  value?: {reference: string, display: string} | null
  placeholder: string
  instanceId?: string
}

export function CareTeamMemberSelect ({ careTeamMembers, onChange, value, placeholder, instanceId }: CareTeamMemberSelectProps): JSX.Element {
  const mappedCareTeamMembers = participantToListItems(careTeamMembers)

  const currentValue = (value?.reference && value.display)
    ? {
      value,
      label: mappedCareTeamMembers
        .find((mctm) => mctm.value.reference === value?.reference)?.label ?? ''
    }
    : null

  return (
    <Grid.SelectWrapper
      label={placeholder}
      data-test={instanceId}
    >
      <Select
        options={mappedCareTeamMembers}
        placeholder={placeholder}
        isClearable
        value={currentValue}
        onChange={(v) => onChange(v?.value ?? null)}
        instanceId={instanceId}
        styles={{
          control: (styles: any, { isFocused }) => ({
            ...styles,
            backgroundColor: '#fff',
            border: '1px solid #DADCE0',
            borderRadius: '4px',
            boxShadow: 'none',
            height: '2.6rem',

            outline: isFocused ? '#5404FF solid 2px' : 'none'
          }),
          container: (styles: any, { isFocused }) => ({
            ...styles,
            flex: 1,
            backgroundColor: '#F6F6F6',
            boxShadow: 'none',
            borderRadius: '8px',
            zIndex: isFocused ? 10 : 5
          }),
          indicatorSeparator: (styles: any) => ({
            ...styles,
            marginBottom: 0,
            marginTop: 0
          }),
          dropdownIndicator: (styles: any) => ({
            ...styles,
            padding: '0 18px'
          })
        }}
      />
    </Grid.SelectWrapper>
  )
}
